// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
.dropdown-content {
  z-index: 10 !important;
}
.bg-log {
  height: 100vh;
  width: 100%;
  background: #b92b27; /* fallback for old browsers */ /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #1565c0,
    #b92b27
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.btn-log{
  border: 0px solid white;
  background: #b92b27; /* fallback for old browsers */ /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #1565c0,
    #b92b27
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

}
.bg-card-ini {
  background: #232526; /* fallback for old browsers */ /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #414345,
    #232526
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.icon-container {
  display: inline-block;
  position: relative;
  cursor: pointer;
}

.text {
  display: none;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.icon-container:hover .text {
  display: block;
}
.preview {
  position: relative;
}

.preview-image {
  position: absolute;
  width: 100px; /* Adjust the width as desired */
  height: auto;
  border: 1px solid #ccc;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  /* Add any other styles you want to customize the preview image */
}
.fw-b {
  font-weight: bold;
}
.gra-text{
  font-weight: bold;
  background: linear-gradient(to right, #e5e5e5, #c0c0c0);
  -webkit-background-clip: text; /* For Safari/Chrome */
  background-clip: text;
  color: transparent; /* Make the text color transparent to show the gradient */
}
/* Example CSS for the file preview tooltip */
.file-preview {
  
  background-color: #ccc;
  height: 200px;
  width: 200px;
  position: fixed;
  top: 50px;
  right: 10px;
  border: 1px solid #ccc;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  z-index: 10!important;
}
.file-preview img{
  height: 200px;
  width: 200px;
  



}
.table td, .table th {
  width: min-content;
  padding: 0.75rem 0.5rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}

.card-body.p-0 .table tbody > tr > td:first-of-type, .card-body.p-0 .table tbody > tr > th:first-of-type, .card-body.p-0 .table tfoot > tr > td:first-of-type, .card-body.p-0 .table tfoot > tr > th:first-of-type, .card-body.p-0 .table thead > tr > td:first-of-type, .card-body.p-0 .table thead > tr > th:first-of-type {
  padding-left: 0.5rem;
}
.btn-anchor {
  background-color: transparent;
  border: none;
  color: #007bff; /* Set the link color to match Bootstrap's primary color */
  text-decoration: underline;
  cursor: pointer; /* Show a pointer cursor on hover to indicate it's clickable */
  padding: 0; /* Remove any padding to make it look like an anchor */
}

.btn-anchor:hover {
  color: #0056b3; /* Change the link color on hover */
}





`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB,EAAE,8BAA8B,EAKhD,+BAA+B;EAClC;;;;GAIC,EAAE,qEAAqE;AAC1E;AACA;EACE,uBAAuB;EACvB,mBAAmB,EAAE,8BAA8B,EAKhD,+BAA+B;EAClC;;;;GAIC,EAAE,qEAAqE;;AAE1E;AACA;EACE,mBAAmB,EAAE,8BAA8B,EAKhD,+BAA+B;EAClC;;;;GAIC,EAAE,qEAAqE;AAC1E;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY,EAAE,gCAAgC;EAC9C,YAAY;EACZ,sBAAsB;EACtB,sCAAsC;EACtC,iEAAiE;AACnE;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,uDAAuD;EACvD,6BAA6B,EAAE,sBAAsB;EACrD,qBAAqB;EACrB,kBAAkB,EAAE,yDAAyD;AAC/E;AACA,6CAA6C;AAC7C;;EAEE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,sCAAsC;EACtC,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,YAAY;;;;;AAKd;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,cAAc,EAAE,0DAA0D;EAC1E,0BAA0B;EAC1B,eAAe,EAAE,8DAA8D;EAC/E,UAAU,EAAE,sDAAsD;AACpE;;AAEA;EACE,cAAc,EAAE,mCAAmC;AACrD","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n.dropdown-content {\n  z-index: 10 !important;\n}\n.bg-log {\n  height: 100vh;\n  width: 100%;\n  background: #b92b27; /* fallback for old browsers */\n  background: -webkit-linear-gradient(\n    to right,\n    #1565c0,\n    #b92b27\n  ); /* Chrome 10-25, Safari 5.1-6 */\n  background: linear-gradient(\n    to right,\n    #1565c0,\n    #b92b27\n  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */\n}\n.btn-log{\n  border: 0px solid white;\n  background: #b92b27; /* fallback for old browsers */\n  background: -webkit-linear-gradient(\n    to right,\n    #1565c0,\n    #b92b27\n  ); /* Chrome 10-25, Safari 5.1-6 */\n  background: linear-gradient(\n    to right,\n    #1565c0,\n    #b92b27\n  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */\n\n}\n.bg-card-ini {\n  background: #232526; /* fallback for old browsers */\n  background: -webkit-linear-gradient(\n    to right,\n    #414345,\n    #232526\n  ); /* Chrome 10-25, Safari 5.1-6 */\n  background: linear-gradient(\n    to right,\n    #414345,\n    #232526\n  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */\n}\n\n.icon-container {\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n}\n\n.text {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 5px;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.icon-container:hover .text {\n  display: block;\n}\n.preview {\n  position: relative;\n}\n\n.preview-image {\n  position: absolute;\n  width: 100px; /* Adjust the width as desired */\n  height: auto;\n  border: 1px solid #ccc;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n  /* Add any other styles you want to customize the preview image */\n}\n.fw-b {\n  font-weight: bold;\n}\n.gra-text{\n  font-weight: bold;\n  background: linear-gradient(to right, #e5e5e5, #c0c0c0);\n  -webkit-background-clip: text; /* For Safari/Chrome */\n  background-clip: text;\n  color: transparent; /* Make the text color transparent to show the gradient */\n}\n/* Example CSS for the file preview tooltip */\n.file-preview {\n  \n  background-color: #ccc;\n  height: 200px;\n  width: 200px;\n  position: fixed;\n  top: 50px;\n  right: 10px;\n  border: 1px solid #ccc;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n  z-index: 10!important;\n}\n.file-preview img{\n  height: 200px;\n  width: 200px;\n  \n\n\n\n}\n.table td, .table th {\n  width: min-content;\n  padding: 0.75rem 0.5rem;\n  vertical-align: top;\n  border-top: 1px solid #dee2e6;\n}\n\n.card-body.p-0 .table tbody > tr > td:first-of-type, .card-body.p-0 .table tbody > tr > th:first-of-type, .card-body.p-0 .table tfoot > tr > td:first-of-type, .card-body.p-0 .table tfoot > tr > th:first-of-type, .card-body.p-0 .table thead > tr > td:first-of-type, .card-body.p-0 .table thead > tr > th:first-of-type {\n  padding-left: 0.5rem;\n}\n.btn-anchor {\n  background-color: transparent;\n  border: none;\n  color: #007bff; /* Set the link color to match Bootstrap's primary color */\n  text-decoration: underline;\n  cursor: pointer; /* Show a pointer cursor on hover to indicate it's clickable */\n  padding: 0; /* Remove any padding to make it look like an anchor */\n}\n\n.btn-anchor:hover {\n  color: #0056b3; /* Change the link color on hover */\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
